/**
 * Core global JS.
 */

// Import SCSS
import '@/client/src/scss/index.scss';

// Instantiate components
// Components
import { ComponentManager } from 'js-component-framework';
import cookiesBannerConfig from '@/client/src/components/cookies-banner';
import headerConfig from '@/client/src/components/header';
import headerSearchConfig from '@/client/src/components/header-search';
import loadMoreConfig from '@/client/src/components/load-more';
import paywallConfig from '@/client/src/components/paywall';
import sidebarNavConfig from '@/client/src/components/sidebar-nav';
import '@/client/src/components/entry-content';
import '@/client/src/components/footer';

// Create instance of the component manager using `aam-us`
const manager = new ComponentManager('aam-us');

// Initialize components
document.addEventListener('DOMContentLoaded', () => {
  // You can supply an array of configurations to start many components at once
  manager.initComponents(
    [
      headerConfig,
      headerSearchConfig,
      loadMoreConfig,
      paywallConfig,
      cookiesBannerConfig,
      sidebarNavConfig,
    ],
  );
});

if (module.hot) {
  module.hot.accept();
  // This is required for HMR, otherwise you'll need to refresh
  // the page to see JS changes
  manager.initComponents(
    [
      headerConfig,
      headerSearchConfig,
      loadMoreConfig,
      paywallConfig,
      cookiesBannerConfig,
      sidebarNavConfig,
    ],
  );
}
